export const activityDrawerSizes = {
  width: 450
}
